import React, {useEffect} from 'react'
import {Col, Row} from 'react-bootstrap'
import ByondGrid2 from "../../../../customGrid/CustomGrid";
import {NodesOfflineGridTemplate} from './NodesOfflineGridTemplate';

export const mapToFriendlyName = (data) => {
  if (!data) {
    return 'Sem dados';
  }
  return data.map(x => <p key={x.id}>{x.friendlyName}</p>);
}

function NodeOfflineDetailType({data, setCurrentDetailType}) {
  const templateGrid = new NodesOfflineGridTemplate(data);
  useEffect(() => {
    if (!data) {
      return
    }
    setCurrentDetailType({
      metadata: templateGrid,
      endpoint: templateGrid.endpoint()
    })
  }, [data])
  return (
    <React.Fragment>
      <Row>
        <Col md={6} className="mt-4">
          <h4 style={{fontWeight: 'bold'}}>Grupo de alerta:</h4>
          <ul>{mapToFriendlyName(data.alertConfiguration.notificationGroups)}</ul>
        </Col>
      </Row>
      <Col md={12}>
        <ByondGrid2 endpoint={templateGrid.endpoint()} metadata={templateGrid} removeBox/>
      </Col>
    </React.Fragment>
  )
}

export {NodeOfflineDetailType}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/NodeOfflineAlert/NodeOfflineDetailType.js